<template>
  <div class="home">
    <div class="Designation">
      <span class="CN">业务办理</span> <span class="EN">Business handling</span>
    </div>
    <div class="bottom_line">
      <i class="left_line"></i>
    </div>
    <div class="subject">
      <template v-for="(item, index) in subjectlist">
        <div
          class="module"
          :class="item.filter"
          :key="index"
          @click="item.filter === 'enable' && Goto(item.url)"
        >
          <img :src="item.image" height="90px" width="90px" />
          <div class="text">
            <p class="CN">{{ item.CN }}</p>
            <p class="EN">{{ item.EN }}</p>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
export default class Home extends Vue {
  private subjectlist: any = [
    {
      image: "/img/salesnetwork.png",
      CN: "营业网点",
      EN: "Business outlets",
      url: "/Salesnetwork",
      filter: "enable",
    },
    {
      image: "/img/Waterquery.png",
      CN: "水费查询",
      EN: "Water fee query",
      url: "/Waterquery",
      filter: "enable",
    },
    {
      image: "/img/bill.png",
      CN: "账单查询",
      EN: "Bill query",
      url: "/Bill",
      filter: "enable",
    },
    {
      image: "/img/waterrate.png",
      CN: "水费缴费",
      EN: "Water bill payment",
      url: "/Waterrate",
      filter: "enable",
    },
    {
      image: "/img/water.png",
      CN: "用水报装",
      EN: "Water application",
      url: "/Water",
      filter: "enable",
    },
    {
      image: "/img/applyfor.png",
      CN: "我的申请",
      EN: "My application",
      url: "/Applyfor",
      filter: "enable",
    },
  ];
  private Goto(url: any) {
    this.$router.push(url);
  }
}
</script>
<style lang="less" scoped>
.home {
  padding: 32px 50px 0;
  .Designation {
    text-align: left;
    display: flex;
    align-items: center;
    margin: 0 14px;
    span.CN {
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #2d2e33;
      margin-right: 8px;
    }
    span.EN {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(182, 185, 194, 0.8);
    }
  }
  .bottom_line {
    margin: 0 14px;
    height: 1px;
    background: #ededed;
    margin-top: 8px;
    position: relative;
    .left_line {
      position: absolute;
      left: 0;
      top: -1px;
      width: 72px;
      height: 3px;
      background: #3d82ee;
    }
  }
  .subject {
    margin-top: 12px;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    .module {
      width: 340px;
      height: 180px;
      background: url("../../public/img/bg@2x.png") no-repeat; //linear-gradient(135deg, #26f1b3 0%, #1b65da 100%),
      background-size: 100% 100%;
      border-radius: 16px;
      margin: 13px;
      transition: all 1000ms;
      display: flex;
      align-items: center;
      justify-content: center;
      &.enable {
        &:hover {
          width: 360px;
          height: 200px;
          margin: 3px;
          cursor: pointer;
        }
      }
      &.filter {
        filter: grayscale(100%); //brightness(20%)//
      }
      img {
        margin-right: 16px;
      }
      .text {
        width: 35%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: left;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #ffffff;
        .CN {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 8px;
        }
        .EN {
          font-size: 12px;
          font-weight: 400;
        }
      }
    }
  }
}
</style>
